
const componentSearch = require('../component-search/component-search.config.js');
const componentHeaderToggle = require('../component-header-toggle/component-header-toggle.config.js');

module.exports = {
	status: 'ready',
	title: 'Header',
	notes: `
		https://www.w3.org/TR/wai-aria-practices/examples/menubar/menubar-1/menubar-1.html
	`,
	context: {
		componentSearch: componentSearch.context,
		componentHeaderToggle: componentHeaderToggle.context,
		inEnglish: 'In English',
		contact: 'Kontakt',
		items: [{
			title: 'Materialprojekt',
			itemsLabel: 'Gå direkt till',
			tabIndex: 3,
			feature: {
				label: 'Läs om hur vi genomför våra projekt',
				title: 'Vi hjälper till att försvara Sverige.',
				text: 'Varje år genomför vi 200 projekt från soldatkängor till ubåtsutveckling. Vi gör det tillsammans med kunder och leverantörer i integrerade projektteam.',
				link: '#'
			},
			items: [{
				title: 'a Projekt-1',
				href: '#'
			}, {
				title: 'Granatkastarpansarbandvagn 90',
				href: '#'
			}, {
				title: 'c Projekt-3',
				href: '#'
			}, {
				title: 'd Projekt-4',
				href: '#'
			}, {
				title: 'e Projekt-5',
				href: '#'
			}]
		}, {
			title: 'Jobb & Karriär',
			itemsLabel: 'Gå direkt till',
			tabIndex: 3,
			feature: {
				label: 'Läs om hur det är att jobba hos oss',
				title: 'Jobba hos oss',
				text: 'Vi utvecklar och levererar teknik, tjänster och materiel till Försvarsmakten. Inte bara det som behövs för att försvara Sverige idag, utan också imorgon. Och dagen efter det.',
				link: '#'
			},
			items: [{
				title: 'a J&K-1',
				href: '#'
			}, {
				title: 'b J&K-2',
				href: '#'
			}]
		}, {
			title: 'Verksamhet',
			itemsLabel: 'Gå direkt till',
			tabIndex: 3,
			feature: {
				label: 'Läs om våran verksamhet',
				title: 'Vår kompetens skapar försvarsförmåga',
				text: 'FMV levererar försvarslogistik. Målet är att erbjuda en kostnadseffektiv och säker materiel- och logistikförsörjning som skapar försvarsförmåga.',
				link: '#'
			},
			items: [{
				title: 'a Verksamhet-1',
				href: '#'
			}, {
				title: 'b Verksamhet-2',
				href: '#'
			}, {
				title: 'c Verksamhet-3',
				href: '#'
			}]
		}, {
			title: 'Om FMV',
			itemsLabel: 'Gå direkt till',
			tabIndex: 3,
			feature: {
				label: 'Läs om FMV',
				title: 'Vi hjälper till att försvara Sverige. ',
				text: 'FMV är en del av det svenska totalförsvaret. Vi är en statlig myndighet med ett viktigt samhällsuppdrag - att leverera materiel och tjänster till det svenska försvaret så att Sveriges soldater och sjömän har det de behöver för att kunna utföra sitt uppdrag.',
				link: '#'
			},
			items: [{
				title: 'a FMV-1',
				href: '#'
			}, {
				title: 'b FMV-2',
				href: '#'
			}, {
				title: 'c FMV-3',
				href: '#'
			}, {
				title: 'd FMV-4',
				href: '#'
			}, {
				title: 'e FMV-5',
				href: '#'
			}, {
				title: 'f FMV-6',
				href: '#'
			}]
		}, {
			title: 'Aktuellt & Press',
			itemsLabel: 'Gå direkt till',
			tabIndex: 3,
			feature: {
				label: 'Se & läs',
				title: 'Press',
				text: 'Varje år genomför vi 200 projekt från soldatkängor till ubåtsutveckling. Vi gör det tillsammans med kunder och leverantörer i integrerade projektteam.',
				link: '#'
			},
			items: [{
				title: 'a A&P-1',
				href: '#'
			}, {
				title: 'b A&P-2',
				href: '#'
			}, {
				title: 'c A&P-3',
				href: '#'
			}]
		}, {
			title: 'Internationellt',
			itemsLabel: 'Gå direkt till',
			tabIndex: 3,
			feature: {
				label: 'Rätt materiel för ett starkare försvar',
				title: 'Internationells',
				text: 'En allt mer globaliserad värld påverkar hur FMV genomför och löser den svenska materielanskaffningen. Här spelar internationella samarbeten en viktig roll.',
				link: '#'
			},
			items: [{
				title: 'Försvarsexport',
				href: '#'
			}, {
				title: 'Europeiska försvarsfonden',
				href: '#'
			}]
		}, {
			title: 'Upphandling',
			itemsLabel: 'Gå direkt till',
			tabIndex: 3,
			feature: {
				label: 'Rätt materiel för ett starkare försvar',
				title: 'Upphandling',
				text: 'FMV upphandlar materiel och tjänster till framför allt Försvarsmakten. Ofta handlar det om tekniskt komplexa och långsiktiga upphandlingar av varor, tjänster och utvecklingsuppdrag. Vi utför också enklare avrop och beställningar.',
				link: '#'
			},
			items: [{
				title: 'Om upphandling',
				href: '#'
			}, {
				title: 'Aktuella upphandlingar',
				href: '#'
			}, {
				title: 'Miljökrav',
				href: '#'
			}]
		}, {
			title: 'In English',
			itemsLabel: 'Gå direkt till',
			tabIndex: 3,
			feature: {
				label: 'The right materiel for a stronger defence',
				title: 'The Swedish Defence Materiel Administration',
				text: 'The Swedish Defence Materiel Administration, FMV, is a governmental agency acting under the Ministry of Defence. We make sure the Swedish Armed Forces have the equipment and logistic services they need to execute their mission. That is our contribution to a stronger defense.',
				link: '#'
			},
			items: [{
				title: 'About FMV',
				href: '#'
			}, {
				title: 'Procurement',
				href: '#'
			}, {
				title: 'Supplier information',
				href: '#'
			}, {
				title: 'Risk Area Vättern',
				href: '#'
			}]
		}]
	}
};
